import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import React from "react";
import {Link} from "react-router-component";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import * as API from "../util/api";
import VLComponent from "./VLComponent";

export default class GSMNetworksScreen extends VLComponent {

    constructor() {
        super();
        this.graphRef = React.createRef();
        this.state = {loaded: false, viewingNetwork: "", data: []};
    }

    componentDidMount() {
        API.POST("systems/gsmNetworks", {}, result => {
            if (result.success) {
                this.setState(result.result, this.loadGraph);
            }
        });
    }

    loadGraph = () => {
        am4core.options.commercialLicense = true;
        let chart = am4core.create(this.graphRef.current, am4charts.XYChart);

        chart.colors.list = [
            am4core.color("#00A0E4"),
            am4core.color(window.primary)
        ];

        let dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.dataFields.category = "carrier";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.min = 0;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "carrier";
        series.dataFields.valueY = "offline";
        series.name = "Offline";
        series.tooltipText = "{valueY.value} systems OFFLINE on {categoryX}";
        series.tooltipHTML = "<span style='color: white'>{valueY.value} systems OFFLINE on {categoryX}</span>";
        series.stacked = true;

        let series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.categoryX = "carrier";
        series2.dataFields.valueY = "cameras";
        series2.name = "Online";
        series2.tooltipText = "{valueY.value} systems on {categoryX} \nClick to view list";
        series2.tooltipHTML = "<span style='color: white'>{valueY.value} systems on {categoryX}<br><i>Click to view list</i></span>";
        series2.stacked = true;

        chart.cursor = new am4charts.XYCursor();

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        // chart.scrollbarX = scrollbarX;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "GSM Networks";
        chart.legend = new am4charts.Legend();

        let data = this.state.data.map(d => {
            return {
                carrier: d.carrier,
                name: "",
                cameras: d.cameras - d.offline,
                offline: d.offline
            };
        });
        chart.data = data;

        chart.events.on("hit", this.clickedGraph, this);

        chart.cursor.events.on("cursorpositionchanged", (ev) => {
            let xAxis = ev.target.chart.xAxes.getIndex(0);
            let date = xAxis.positionToCategory(xAxis.toAxisPosition(ev.target.xPosition));
            this.hoveredDate = (date);
        });

        this.chart = chart;
        setTimeout(() => this.setState({loaded: true}), 600);

    };

    clickedGraph = () => {
        console.log(this.hoveredDate);
        this.setState({viewingNetwork: this.hoveredDate});
    };

    render() {
        return (
            <div>
                <ActionBar title="GSM / IP Networks"/>
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16,
                    height: "calc(100vh - 85px)", overflowY: "auto"
                }}>

                    <div ref={this.graphRef} style={{height: "100%", width: "100%"}}/>

                </div>
                <Loader loaded={this.state.loaded}/>

                {this.renderPopup()}
            </div>
        );
    }

    getCameras = () => {
        let cams = this.state.data.filter(e => e.carrier == this.state.viewingNetwork);
        if (cams == null || cams[0] == null) {
            return [];
        }
        return cams[0].ids || [];
    };

    renderPopup = () => {
        if (this.state.viewingNetwork == "") {
            return;
        }
        return <div style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#00000055",
            zIndex: 10000
        }}>
            <div style={{maxHeight: "90vh", width: "50vw", overflowY: "auto"}}>
                <table className="w3-table-all">
                    <thead>
                    <tr>
                        <div style={{textAlign: "right"}}>
                            <i className="material-icons hoverable" onClick={() => this.setState({viewingNetwork: ""})}>clear</i>
                        </div>
                    </tr>
                    <tr>
                        <th>{this.state.viewingNetwork} Systems</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.getCameras().map(this.drawRow)}
                    </tbody>
                </table>
            </div>
        </div>;
    };

    drawRow = c => {
        let link = (c.type == 1 ? "/camera/" : "/sensor/") + c.id;
        return <tr style={{background: c.online == 1 ? "" : "#00A0E4"}}>
            <td><Link href={link}>{c.name}</Link></td>
        </tr>
    }

}
